import React, { useEffect, useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { clientService } from '../../api';
import { SarsDialog, SarsTable, useSarsActions } from './Sars';

export const ClientSarsPanel = ({ clientId }) => {
  const [items, setItems] = useState([]);
  const load = () => clientService.sarsForClient(clientId).then(setItems);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [clientId]);
  const { dialog, setDialog, remove, openNew, openEdit } = useSarsActions(load);
  return (
    <div className="rounded-xl bg-white border border-stone-200 overflow-hidden" data-testid="client-sars-panel">
      <div className="p-5 border-b border-stone-100 flex items-center justify-between gap-3">
        <div>
          <div className="font-semibold text-stone-900">SARS correspondence</div>
          <div className="text-xs text-stone-500 mt-0.5">Letters, verifications, audits and objections. Response deadlines become tasks.</div>
        </div>
        <Button size="sm" onClick={openNew} className="bg-emerald-800 hover:bg-emerald-900 text-white" data-testid="new-sars-btn"><Plus size={14} className="mr-1.5"/> Log item</Button>
      </div>
      <SarsTable items={items} onEdit={openEdit} onDelete={remove}/>
      <SarsDialog open={dialog.open} onOpenChange={(o) => setDialog({ ...dialog, open: o })} item={dialog.item} clients={[]} fixedClientId={clientId} onSaved={load}/>
    </div>
  );
};
